const Footer = () => {
  return (
  <footer>
      <p>Made with ❤️ by Dilip Singh</p>
      <p> &copy; 2022 </p>
      <a href="/about">About</a>
  </footer>
  )
};

export default Footer;